import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();

  private progressTimer?: Subscription;

  show() {
    Promise.resolve().then(() => {
      this.progressTimer?.unsubscribe();
      this.loadingSubject.next(true);
      this.progressSubject.next(0);

      // Fake smooth progress
      this.progressTimer = interval(100).subscribe(() => {
        let current = this.progressSubject.value;
        if (current < 90) {
          this.progressSubject.next(current + 5); // 5% per tick
        }
      });
    });
  }

  showProgressForDuration(durationMs: number = 3000): Promise<void> {
    this.progressTimer?.unsubscribe();
    this.loadingSubject.next(true);
    this.progressSubject.next(0);

    const stepTime = 100;
    const totalSteps = Math.max(1, Math.round(durationMs / stepTime));
    let currentStep = 0;

    return new Promise<void>(resolve => {
      this.progressTimer = interval(stepTime).subscribe(() => {
        currentStep++;
        const pct = Math.min(100, Math.round((currentStep / totalSteps) * 100));
        this.progressSubject.next(pct);

        if (currentStep >= totalSteps) {
          this.progressTimer?.unsubscribe();
          setTimeout(() => {
            resolve();
          }, 150);
        }
      });
    });
  }

  hide() {
    // Jump to 100%
    this.progressSubject.next(100);

    // Stop fake progress after short delay
    setTimeout(() => {
      this.progressTimer?.unsubscribe();
      this.loadingSubject.next(false);
      this.progressSubject.next(0);
    }, 300);
  }
}
